export function isValidationRuleNumber(rule: unknown): rule is number {
  return Boolean(rule && Number.isInteger(rule));
}
